import { render } from "./ModelsOnboardingPanel.vue?vue&type=template&id=3bb8661b&scoped=true"
import script from "./ModelsOnboardingPanel.vue?vue&type=script&lang=js"
export * from "./ModelsOnboardingPanel.vue?vue&type=script&lang=js"

import "./ModelsOnboardingPanel.vue?vue&type=style&index=0&id=3bb8661b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb8661b"]])

export default __exports__